import { module } from 'stereomodularjs';
import svgIco from '../components/svgIco.vue'
import Note from '../components/Note.vue'
import Programs from '../components/Programs.vue'
import NewCarPayments from '../components/NewCarPayments.vue'
import { createApp } from "vue/dist/vue.esm-bundler.js"

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const app = createApp({
            template: '<NewCarPayments />',
            components: { svgIco, NewCarPayments, Note, Programs},
            data() {
                return {
                    spriteURL: self.el.dataset.sprite
                }
            }
        })

        app.component("svgIco", svgIco)
        app.component("Note", Note)
        app.component("Programs", Programs)
        app.config.globalProperties.cash = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' $';
        }
        app.config.globalProperties.cents = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' $';
        }
        app.config.globalProperties.pct = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' %';
        }
        app.config.globalProperties.nb = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        app.mount(self.el)

    }
}
